export const MEDIA_POLICY_KEYS = Object.freeze({
  SEO_HERO: 'seoHero',
  SECTION_FULL_WIDTH: 'sectionFullWidth',
  SECTION_SPLIT: 'sectionSplit',
  CARD: 'card',
  THUMBNAIL: 'thumbnail'
})

export const MEDIA_POLICIES = Object.freeze({
  [MEDIA_POLICY_KEYS.SEO_HERO]: Object.freeze({
    priority: true,
    quality: 60,
    sizes: '100vw'
  }),
  [MEDIA_POLICY_KEYS.SECTION_FULL_WIDTH]: Object.freeze({
    priority: false,
    quality: 68,
    sizes: '100vw'
  }),
  [MEDIA_POLICY_KEYS.SECTION_SPLIT]: Object.freeze({
    priority: false,
    quality: 68,
    sizes: '(max-width: 767px) 100vw, (max-width: 1279px) 50vw, 720px'
  }),
  [MEDIA_POLICY_KEYS.CARD]: Object.freeze({
    priority: false,
    quality: 64,
    sizes: '(max-width: 767px) 100vw, (max-width: 1279px) 50vw, 33vw'
  }),
  [MEDIA_POLICY_KEYS.THUMBNAIL]: Object.freeze({
    priority: false,
    quality: 60,
    sizes: '(max-width: 767px) 25vw, 180px'
  })
})

export const resolveMediaPolicy = ({ policy, priority, quality, sizes } = {}) => {
  const defaults = MEDIA_POLICIES[policy] || {}

  return {
    priority: priority ?? defaults.priority ?? false,
    quality: quality ?? defaults.quality,
    sizes: sizes ?? defaults.sizes ?? '100vw'
  }
}

